<template>
  <PageTable />
</template>
<script>
import PageTable from './components/table'
export default {
  name: 'customerManage-customerQuotation',
  components: { PageTable },
}
</script>
